export default __webpack_public_path__ + "static/133-115a685f28ef14531fc786afab4b1a52.jpg";